import { Box, Typography } from '@mui/material';
import React from 'react';

interface ItemsCountProps {
    label: any
    centered?: boolean
}
function ItemsCount({ label, centered }: ItemsCountProps) {
    return (
        <div style={centered ? { width: "100%", display: "flex", justifyContent: "center" } : {}}>
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: '#f0f0f0', // Light gray background
                    borderRadius: '12px', // Rounded corners
                    padding: '4px 8px', // Padding around the text
                }}
            >
                <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', md: '1rem' }, fontWeight: 'bold' }}>
                    {label}
                </Typography>
            </Box>
        </div>
    );
}

export default ItemsCount;